import $ from 'jquery';

export default class CampaignForm {
  static init() {
    this.initSegmentationFieldsToggle();
  }

  static initSegmentationFieldsToggle() {
    const $campaignAccessibleAfterLoginInput = $('.js__campaign-accessible-after-login');

    if ($campaignAccessibleAfterLoginInput.length) {
      $campaignAccessibleAfterLoginInput.on('change', e => {
        this.toggleSegmentationFields($(e.currentTarget));
      });

      this.toggleSegmentationFields($campaignAccessibleAfterLoginInput);
    }
  }

  static toggleSegmentationFields($campaignAccessibleAfterLoginInput) {
    const isAccessibleAfterLogin = $campaignAccessibleAfterLoginInput.is(':checked');
    const $segmentsSelectInput = $('.js__segments-select');

    $segmentsSelectInput.toggleClass('disabled', !isAccessibleAfterLogin);
    $segmentsSelectInput.find('input').prop('disabled', !isAccessibleAfterLogin);
    $segmentsSelectInput.parent().toggle(isAccessibleAfterLogin);
  }
}
